import {DateRange, EmptyDateRange} from 'Core/models/DateRange';

export type AgentNewsFilter = {
  title: string;
  description: string;
  publishDate: DateRange;
};

export const EmptyAgentNewsFilter = {
  title: '',
  description: '',
  publishDate: EmptyDateRange,
};
